import { Component, OnInit } from '@angular/core';

interface Person {
  shd: string;
  lhd: string;
  bthd: string;
  kthd: string;
}

@Component({
  selector: 'app-hop-dong',
  templateUrl: './hop-dong.component.html',
  styleUrls: ['./hop-dong.component.scss']
})
export class HopDongComponent implements OnInit {
  listOfData: Person[] = [
    {
      shd: '1912',
      lhd: 'Lao động',
      bthd: '30/02/2019',
      kthd: '30/02/2022'
    },
    {
      shd: '1212',
      lhd: 'Lao động',
      bthd: '30/02/2019',
      kthd: '30/02/2022'
    },
    {
      shd: '1913',
      lhd: 'Lao động',
      bthd: '30/02/2019',
      kthd: '30/02/2022'
    }
  ];
  constructor() { }

  ngOnInit() {
  }

}
